import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./video-topbar.css?vue&type=style&index=0&id=e5b66368&scoped=true&lang=css&external"
import "./workspace-create-dialog.css?vue&type=style&index=1&lang=css&external"
import "./Sidebar.vue?vue&type=style&index=2&id=e5b66368&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5b66368"]])

export default __exports__